export default __webpack_public_path__ + "images/66aa0bc498569bd9b68517a343899eef.png";